import { DownOutlined, FilterFilled, PlusOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { DESC, ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import React, { useEffect, useState } from 'react';
import { getPaginationState, log } from 'react-jhipster';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container } from 'reactstrap';

import type { DragEndEvent } from '@dnd-kit/core';
import { DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy
} from '@dnd-kit/sortable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Checkbox, Col, Dropdown, Input, Menu, notification, Row, Select, Tooltip } from 'antd';
import { TableRowSelection } from 'antd/es/table/interface';
import Title from 'antd/es/typography/Title';
import { APP_LOCAL_DATE_FORMAT_PAYLOAD, ObjectiveSymbol } from 'app/config/constants';
import ActivitiesUpdate from 'app/entities/activities/form/activities-update';
import ApprovalLevel from 'app/entities/approval-level/view/approval-level';
import CategoryApproveComponent from 'app/entities/approval-level/view/modal/category-approve';
import { getCurrentStatusProcess, getCurrentStatusProcessAdjustment, reset, resetApprovalEntity, submitApprove } from 'app/entities/approval-level/view/modal/category-approve.reducer';
import { getCurrentCheckInType } from 'app/entities/checkIn/checkIn.reducer';
import { getOnlyOrgView as getEmployees } from 'app/entities/common/common.reducer';
import EvaluationLevel from 'app/entities/evaluation-level/view/evaluation-level';
import CategoryEvaluationComponent from 'app/entities/evaluation-level/view/modal/category-evaluation';
import { fetchCurrentStatusProcess } from 'app/entities/evaluation-level/view/modal/category-evaluation.reducer';
import ResultCompleteComponent from 'app/entities/evaluation-level/view/modal/confirm-complete/result-confirm-complete';
import { setFilterObjective, setFilterOrgCheckIn, setFilterPendingApprove, setListFilterOrgCheckIn } from 'app/entities/filters/filters.reducer';
import CopyKR from 'app/entities/kr/form/copy/copy-kr';
import { ReportKr as ReportMidYear } from 'app/entities/kr/form/report/form/reportKr';
import { ReportKr as ReportHalfMonth } from 'app/entities/kr/form/report/half-month/reportKr';
import { ReportKr as ReportMonth } from 'app/entities/kr/form/report/month/reportKr';
import { ReportKr as ReportQuarter } from 'app/entities/kr/form/report/quarter/reportKr';
import { deleteEntity as deleteKr } from 'app/entities/kr/kr.reducer';
import { getEntities as getPlanPeriods } from 'app/entities/plan-period/plan-period.reducer';
import { getByMonth } from 'app/entities/report-schedule/report-schedule.reducer';
import ModalConfirmComponent from 'app/shared/component/modal/confirm';
import { DraggableRow } from 'app/shared/component/table/drag-drop-row';
import TableComponent from 'app/shared/component/table/table';
import { PlantPeriodType } from 'app/shared/model/enum/plantPeriod.enum';
import { filterOption } from 'app/shared/util/select-filter';
import dayjs from 'dayjs';
import { saveAs } from 'file-saver';
import * as _ from 'lodash';
import { ReactSVG } from 'react-svg';
import CopyObjective from '../form/copy/copy-objective';
import ObjectiveUpdate from '../form/objective-update';
import { deleteEntity as deleteObjective, dragAndDropItem, exportExcel, getEntities } from '../objective.reducer';
import { actionsEvaluation, columns, columnsExpand, versionPlanPeriodYear } from './config';
import FilterModal from './filter/filter';
import AdjustWeight from './modal/adjust-weight';
import CheckInListComponent from './modal/check-in/list';
import OrganizationActiveCheckIn from './modal/check-in/organization-active-check-in';
import ConfirmComplete from './modal/confirm-complete';
import ConfirmCompleteQuarter from './modal/confirm-complete-quarter';
import CopyKRComponent from './modal/copy-kr/copy-kr';
import ExportExcelComponent from './modal/export-excel';
import { ConfirmComplete as ConfirmCompleteHalfMonth } from './modal/half-month/confirm-complete';
import { ConfirmComplete as ConfirmCompleteMonth } from './modal/month/confirm-complete';
import './style.scss';
import PendingApproval from 'app/entities/approval-level/view/modal/pending-approval';
import ApproveAdjustedObjectiveKRComponent from 'app/entities/approval-level/view/modal/approve-adjusted-objective';
import ApproveAdjustedYearComponent from 'app/entities/approval-level/view/modal/approve-adjusted-year';
const { Search } = Input;

export const Objective = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const pageLocation = useLocation();
  const searchParams = new URLSearchParams(pageLocation.search);

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'lastModifiedDate', DESC), pageLocation.search),
  );

  const objectiveList = useAppSelector(state => state.objective.entities);
  const totalItems = useAppSelector(state => state.objective.totalItems);
  const isLoading = useAppSelector(state => state.objective.loading);
  const planPeriodList = useAppSelector(state => state.planPeriod.entities);
  const filters = useAppSelector(state => state.filters.objective);
  const employeeList = useAppSelector(state => state.common.orgsView);
  const reportSchedules = useAppSelector(state => state.reportSchedule.options);
  const account = useAppSelector(state => state.authentication.account);
  const updating = useAppSelector(state => state.categoryApprove.updating);
  const currentStatusProcessEvaluate = useAppSelector(state => state.categoryEvaluation.entity);
  const currentStatusProcessApprove = useAppSelector(state => state.categoryApprove.entity);
  const currentStatusProcessAdjustment = useAppSelector(state => state.categoryApprove.entityAdjustment);
  const isCheckInDisabled =
    (Object.keys(currentStatusProcessEvaluate).length > 0 && !currentStatusProcessEvaluate?.isFinished) ||
    (Object.keys(currentStatusProcessAdjustment).length > 0 && !currentStatusProcessAdjustment?.isFinished);

  const [visibleConfirmDelete, setVisibleConfirmDelete] = useState(false);
  const [idSelectedObjective, setIdSelectedObjective] = useState(null);
  const [objectiveSelected, setSelectedObjective] = useState(null);
  const [krBaseSelected, setKrBaseSelected] = useState(null);
  const [visibleFilter, setFilterModalVisible] = useState(false);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [data, setData] = useState([]);
  const [checkedList, setCheckedList] = useState<string[]>(['action']);
  const [columnConfig, setColumnConfig] = useState<any[]>([]);
  // const [isOpenModalFormKr, setIsOpenModalFormKr] = useState(false);
  const [isOpenModalFormObjective, setIsOpenModalFormObjective] = useState(false);
  const [isOpenModalFormActivities, setOpenModalFormActivities] = useState(false);
  const [isOpenModalContribution, setOpenModalContribution] = useState(false);
  const [isOpenModalReportKr, setOpenModalReportKr] = useState(false);
  const [isOpenModalReportKrFirstQuarter, setOpenModalReportKrFirstQuarter] = useState(false);
  const [isOpenModalConfirmComplete, setOpenModalConfirmComplete] = useState(false);
  const [isOpenModalConfirmCompleteQuarter, setOpenModalConfirmCompleteQuarter] = useState(false);
  const [isOpenModalExport, setOpenModalExport] = useState(false);
  const [contextMenuObjective, setContextMenuObjective] = useState(null);
  const [menuObjectivePosition, setMenuObjectivePosition] = useState({ x: 0, y: 0 });
  const [contextMenuKr, setContextMenuKr] = useState(null);
  const [menuKrPosition, setMenuKrPosition] = useState({ x: 0, y: 0 });
  const [isOpenModalReportKrHalfMonth, setOpenModalReportKrHalfMonth] = useState(false);
  const [isOpenModalReportKrMonth, setOpenModalReportKrMonth] = useState(false);
  const [isOpenModalConfirmCompleteHalfMonth, setOpenModalConfirmCompleteHalfMonth] = useState(false);
  const [isOpenModalConfirmCompleteMonth, setOpenModalConfirmCompleteMonth] = useState(false);
  const [isOpenModalCheckInList, setOpenModalCheckInList] = useState(false);
  const [isOpenModalCheckIn, setOpenModalCheckIn] = useState(false)
  const [isOpenModalFormCopyObjective, setOpenModalFormCopyObjective] = useState(false);
  const [isOpenModalFormCopyKR, setOpenModalFormCopyKR] = useState(false);
  const [isOpenModalApprove, setOpenModalApprove] = useState(false);
  const [isOpenModalEvaluation, setOpenModalEvaluation] = useState(false);
  const [isOpenModalListKrCopy, setOpenModalListKrCopy] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [isOpenModalCategoryApprove, setOpenModalCategoryApprove] = useState(false);
  const [isOpenModalCategoryEvaluation, setOpenModalCategoryEvaluation] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [isOpenModalConfirmApprove, setOpenModalConfirmApprove] = useState(false);
  const [isOpenModalResultComplete, setOpenModalResultComplete] = useState(false);
  const [isOpenModalAdjustedObjective, setOpenModalAdjustedObjective] = useState(false);
  const [isOpenModalAdjustmentYear, setOpenModalAdjustmentYear] = useState(false);

  const actionsObjective = [
    {
      key: 2,
      disabled: isCheckInDisabled,
      label: 'Check in',
    },
    {
      key: 3,
      label: 'Danh mục check in',
    },
    {
      key: 4,
      label: 'Xác nhận hoàn thành check in',
    }
  ];

  const actionsApprove = [
    {
      key: 1,
      label: 'Thiết lập cấp phê duyệt',
    },
    {
      key: 2,
      label: 'Trình phê duyệt',
      disabled: Object.keys(currentStatusProcessApprove).length > 0 && !currentStatusProcessApprove?.isFinished,
    },
    {
      key: 3,
      label: 'Phê duyệt',
    },
    {
      key: 5,
      label: 'Trình phê duyệt điều chỉnh',
      disabled: Object.keys(currentStatusProcessAdjustment).length > 0 && !currentStatusProcessAdjustment?.isFinished,
    },
  ];

  const dropDownAction = [
    {
      key: 1,
      label: 'Thêm mới KR',
      onclick: item => handleAddKr(item.id),
      show: true, //isAdmin || activitiesPermissions.Add,
    },
    {
      key: 5,
      label: `Thêm mới KR từ KR ${filters?.year - 1}`,
      onclick: item => handleOpenModalListKrCopy(item),
      show: true
    },
    {
      key: 2,
      label: 'Xem danh sách KR',
      onclick: item => handleViewListKr(item.id),
      show: true, //isAdmin || activitiesPermissions.Add,
    },
    {
      key: 3,
      label: 'Thêm mới công việc',
      onclick: item => handleAddActivities(item),
      show: true, //isAdmin || objectivePermissions.UpdateWeight,
    },
    {
      key: 4,
      label: 'Copy',
      onclick: (item) => handleCopyObjective(item.id),
      show: true,
    },
  ];

  const dropDownKrAction = [
    {
      key: '2',
      label: 'Copy',
      onclick: (item) => handleCopyKr(item),
      show: true,
    },
    {
      key: 3,
      label: 'Thêm mới công việc',
      onclick: item => handleAddActivities(item),
      show: true, //isAdmin || objectivePermissions.UpdateWeight,
    },
  ];


  const pinColumns: any = [
    {
      title: 'Mã',
      sorter: true,
      width: 90,
      fixed: 'left',
      key: 'code',
      defaultShow: true,
      dataIndex: 'code',
    },
    {
      title: 'Lĩnh vực,Dự án,Mảng CV',
      key: 'fieldName',
      fixed: 'left',
      width: 120,
      render(item) {
        const { fieldName, projectName, workTypeName } = item;

        if (!fieldName && !projectName && !workTypeName) return null;

        const segments = [fieldName, projectName, workTypeName].filter(Boolean);

        return (
          <div>
            {segments.map((segment, index) => (
              <p key={index}>- {segment}</p>
            ))}
          </div>
        );
      }
    },
  ];

  const newColumns = columnConfig.map(item => ({
    ...item,
    hidden: !checkedList.includes(item.key),
  }));

  useEffect(() => {
    const hasRequiredFilters = filters && filters?.accountableId && filters?.year && filters?.planPeriodId;

    if (hasRequiredFilters) {
      handleFetCurrentStatusProcessEvaluate(filters?.accountableId, filters?.year);
      handleFetCurrentStatusProcessApprove(filters?.accountableId, filters?.year);
      handleFetCurrentStatusProcessAdjustment(filters?.accountableId, filters?.year);
    }
  }, [filters]);

  useEffect(() => {
    if (planPeriodList?.length > 0 && !filters?.planPeriodId) {
      handleChangePlanPeriod(planPeriodList[0].id);
    }
  }, [planPeriodList]);

  useEffect(() => {
    if (filters?.accountableId && filters?.year && filters?.planPeriodId) {
      handleFetCurrentStatusProcessEvaluate(filters?.accountableId, filters?.year);
      handleFetCurrentStatusProcessApprove(filters?.accountableId, filters?.year);
      handleFetCurrentStatusProcessAdjustment(filters?.accountableId, filters?.year);
    }
  }, [filters?.planPeriodId, filters?.year]);

  useEffect(() => {
    if (versionPlanPeriodYear?.length > 0 && !filters?.adjustPlanPeriod && filters?.planPeriodType === PlantPeriodType.Year) {
      handleChangeAdjustPlanPeriods(versionPlanPeriodYear[0].value);
    }
  }, [filters?.planPeriodType]);

  useEffect(() => {
    setCheckedList(_.uniq([...checkedList, ...[...createPinColumns(), ...columns, ...columnsExpand].map(x => {
      if (x.defaultShow) {
        return x.key
      }
    }
    )]));
  }, [filters.planPeriodType]);

  useEffect(() => {
    setColumnConfig(createColumns());
  }, [checkedList, filters.planPeriodType]);

  useEffect(() => {
    if (objectiveList) {
      // Extract keys of all rows for expanding all rows
      const allRowKeys = getAllRowKeys(objectiveList);
      setExpandedRowKeys(allRowKeys);
      setData(
        objectiveList?.map(item => {
          return {
            ...item,
            key: item.id,
            contribution: item.contribution,
            children:
              item.keyResults &&
              item.keyResults.map(child => {
                return {
                  ...child,
                  key: child.id,
                };
              }),
          };
        }),
      );
    }
  }, [objectiveList]);

  useEffect(() => {
    getAllEntities();
  }, [paginationState, filters]);

  const handleAddColumnView = values => {
    setCheckedList([...values, 'action']);
  };

  const createPinColumns = () => {
    if (filters?.planPeriodType === PlantPeriodType.Quarter) {
      pinColumns.push(
        {
          title: 'Mục tiêu và KR cả năm',
          fixed: 'left',
          sorter: true,
          width: 250,
          defaultShow: true,
          key: 'purposeYear',
          render: value => (
            <div className={`${!value.objectiveId ? 'fw-bold' : ''}`}>{value.purposeYear}</div>
          ),
        },
        {
          title: 'KR quý',
          fixed: 'left',
          sorter: true,
          width: 250,
          defaultShow: true,
          key: 'purposeQuarter',
          dataIndex: 'purposeQuarter'
        })
    }
    else if (filters?.planPeriodType === PlantPeriodType.Month) {
      pinColumns.push(
        {
          title: 'Mục tiêu và KR cả năm',
          fixed: 'left',
          sorter: true,
          width: 250,
          defaultShow: true,
          key: 'purposeYear',
          render: value => (
            <div className={`${!value.objectiveId ? 'fw-bold' : ''}`}>{value.purposeYear}</div>
          ),
        },
        {
          title: 'KR quý',
          fixed: 'left',
          sorter: true,
          width: 250,
          defaultShow: true,
          key: 'purposeQuarter',
          dataIndex: 'purposeQuarter'
        },
        {
          title: 'KR tháng',
          fixed: 'left',
          sorter: true,
          width: 250,
          defaultShow: true,
          key: 'purposeMonth',
          dataIndex: 'purposeMonth'
        })
    }
    else {
      pinColumns.push(
        {
          title: 'Mục tiêu và Kết quả then chốt',
          fixed: 'left',
          sorter: true,
          width: 250,
          defaultShow: true,
          key: 'purposeYear',
          render: value => (
            <div className={`${!value.objectiveId ? 'fw-bold' : ''}`}>{value.purposeYear}</div>
          ),
        })
    }
    return pinColumns;
  }

  const createColumns = () => {
    const column = [];
    column.push({
      key: 'action',
      fixed: 'left',
      width: 100,
      filterDropdown: () => (
        <Checkbox.Group
          className="d-grid gap-3 p-3 overflow-auto height-350 align-items-center"
          value={checkedList}
          options={_.uniqBy([...createPinColumns(), ...columns, ...columnsExpand], (o) => { return o.key }).map(x => {
            return {
              label: x.title,
              value: x.key,
            };
          })}
          onChange={handleAddColumnView}
        />
      ),
      filterIcon: () => <FilterFilled style={{ color: checkedList.length > 0 ? '#1890ff' : undefined }} />,
      render: (item: any) => (
        <div className="action">
          <span className="action-edit">
            {item.editable && (
              <Tooltip title="Sửa">
                <FontAwesomeIcon
                  onClick={() => {
                    !item.objectiveId ? handleEditObjective(item.id) : handleEditKr(item);
                  }}
                  icon="pencil-alt"
                />
              </Tooltip>
            )}
          </span>
          <span className="action-delete">
            {item.deleteable && (
              <Tooltip title="Xóa">
                <FontAwesomeIcon
                  onClick={() => {
                    !item.objectiveId ? handleWarningDeleteItem(item.id) : handleWarningDeleteItemExpand(item);
                  }}
                  icon="trash"
                />
              </Tooltip>
            )}
          </span>
        </div>
      ),
    });

    column.push(...createPinColumns(), ...columns, ...columnsExpand);
    return column;
  };

  const getAllEntities = () => {
    if (filters && filters.planPeriodId && filters.accountableId) {
      dispatch(
        getEntities({
          includeKr: filters?.includeKr === 2 ? true : false,
          searchText: filters?.searchText,
          page: paginationState.activePage,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
          accountableId: filters?.accountableId,
          reportScheduleId: filters?.reportScheduleId || (reportSchedules?.length > 0 ? reportSchedules[0].value : null),
          creatorId: filters?.creatorId,
          dueDate: filters?.dueDate && dayjs(filters?.dueDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
          fieldValue: filters?.fieldValue,
          projectId: filters?.projectId,
          workStatus: filters?.workStatus,
          planPeriodId: filters.planPeriodId,
          workTypeId: filters?.workTypeId,
          krAccountableId: filters?.krAccountableId,
          adjustPlanPeriod: filters?.adjustPlanPeriod || null,
          startDate: filters?.startDate && dayjs(filters?.startDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
        }),
      );
    }
  };


  useEffect(() => {
    dispatch(getPlanPeriods({}));
    dispatch(getEmployees());
  }, []);

  const scrollToRow = () => {
    const storedRowIndex = localStorage.getItem('scrollToRow');
    // Scroll to the specific row
    const tableBody = document.querySelector('.ant-table-body');
    if (tableBody) {
      const row = tableBody.querySelector(`[data-row-key="${storedRowIndex}"]`);
      if (row) {
        row.scrollIntoView({ behavior: 'instant' });
      }
    }
  }

  useEffect(() => {
    // Delay the scroll action to ensure the table has fully rendered
    const timer = setTimeout(() => {
      scrollToRow();
    }, 500); // Adjust the delay if necessary

    return () => clearTimeout(timer);
  }, [data]); // Dependency array ensures this effect runs when data changes

  useEffect(() => {
    if (employeeList && employeeList.length > 0 && !filters?.accountableId) {
      handleChangeEmployee(employeeList[0].id)
    }
    else if (filters && filters.accountableId) {
      handleChangeEmployee(filters.accountableId)
    }
  }, [employeeList])

  useEffect(() => {
    if (filters?.accountableId && filters?.year && filters?.planPeriodId) {
      handleFetCurrentStatusProcessEvaluate(filters?.accountableId, filters?.year);
      handleFetCurrentStatusProcessApprove(filters?.accountableId, filters?.year);
      handleFetCurrentStatusProcessAdjustment(filters?.accountableId, filters?.year);
    }
  }, [filters?.accountableId]);

  const handleChange = (pageNumber: number, size: number, sorter: any) => {
    setPaginationState({
      ...paginationState,
      order: DESC, //sorter.order && OrderByType[sorter.order] === OrderByType.descend ? DESC : ASC,
      sort: sorter.columnKey,
      activePage: pageNumber,
      itemsPerPage: size,
    });
  };

  const handleFreeTextSearchQuery = query => {
    dispatch(setFilterObjective({ ...filters, searchText: query }));
  };

  const handleWarningDeleteItem = (id: number) => {
    setVisibleConfirmDelete(true);
    setIdSelectedObjective(id);
  };

  const handleWarningDeleteItemExpand = (id: number | string) => {
    setVisibleConfirmDelete(true);
    setKrBaseSelected(id);
  };

  const handleConfirmDelete = () => {
    if (idSelectedObjective) {
      dispatch(deleteObjective(idSelectedObjective))
        .then(() => {
          setExpandedRowKeys([]);
          setIdSelectedObjective(null);
          getAllEntities();
        })
        .finally(() => {
          setVisibleConfirmDelete(false);
        });
    } else {
      dispatch(deleteKr(krBaseSelected?.id))
        .then(() => {
          getAllEntities();
          setKrBaseSelected(null);
        })
        .finally(() => {
          setVisibleConfirmDelete(false);
        });
    }
  };

  const handleChangePlanPeriod = (value: string) => {
    const detailPlanPeriod = _.find(planPeriodList, o => o.id === value);

    if (detailPlanPeriod) {
      // Reset reportScheduleId trước khi thay đổi planPeriod
      const baseFilterUpdate = {
        ...filters,
        reportScheduleId: null,
        adjustPlanPeriod: detailPlanPeriod.planPeriodType === PlantPeriodType.Year ?
          (versionPlanPeriodYear?.length > 0 ? versionPlanPeriodYear[0].value : null) : null,
        planPeriodName: detailPlanPeriod.name,
        planPeriodId: value,
        startDate: dayjs(detailPlanPeriod.startDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
        dueDate: dayjs(detailPlanPeriod.endDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
        planPeriodType: detailPlanPeriod.planPeriodType,
        year: detailPlanPeriod.year,
        month: detailPlanPeriod.month,
        quarter: detailPlanPeriod.quarter,
      };

      if (detailPlanPeriod.planPeriodType === PlantPeriodType.Month) {
        dispatch(getByMonth(detailPlanPeriod.month)).then((response) => {
          // Sau khi load xong reportSchedules, set giá trị đầu tiên
          if (response && response.payload) {
            const reportData = response.payload as any;
            if (reportData.data && reportData.data.length > 0) {
              dispatch(
                setFilterObjective({
                  ...baseFilterUpdate,
                  reportScheduleId: reportData.data[0].value,
                }),
              );
              return;
            }
          }
          // Fallback nếu không có data
          dispatch(setFilterObjective(baseFilterUpdate));
        });
      } else {
        dispatch(setFilterObjective(baseFilterUpdate));
      }
    }
  };

  const handleChangeAdjustPlanPeriods = value => {
    dispatch(
      setFilterObjective({
        ...filters,
        adjustPlanPeriod: value || null,
      }),
    );
  };

  const handleChangeReportSchedule = value => {
    dispatch(
      setFilterObjective({
        ...filters,
        reportScheduleId: value,
      }),
    );
  };

  const handleChangeEmployee = (value: string) => {
    const employee = _.find(employeeList, o => o.id === value);
    dispatch(
      setFilterObjective({
        ...filters,
        accountableId: value,
        accountableName: employee?.name,
      }),
    );
  };

  const handleExport = () => {
    dispatch(
      exportExcel({
        includeKr: filters?.includeKr === 2 ? true : false,
        searchText: filters?.searchText,
        accountableId: filters?.accountableId,
        creatorId: filters?.creatorId,
        dueDate: filters?.dueDate && dayjs(filters?.dueDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
        fieldValue: filters?.fieldValue,
        projectId: filters?.projectId,
        workStatus: filters?.workStatus,
        planPeriodId: filters.planPeriodId,
        workTypeId: filters?.workTypeId,
        startDate: filters?.startDate && dayjs(filters?.startDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
      }),
    ).then(response => {
      if (response.payload) {
        const result = response.payload as any;
        saveAs(
          new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
          `Danh sách mục tiêu_${dayjs().format('DDMMYYYYhhmmss')}`,
        );
      }
    });
  };

  const getAllRowKeys = item => {
    return item.reduce((keys, value) => {
      keys.push(value.id);

      if (value.keyResults) {
        keys = keys.concat(getAllRowKeys(value.keyResults));
      }

      return keys;
    }, []);
  };

  const handleChangeDisplayTable = value => {
    dispatch(setFilterObjective({ ...filters, includeKr: value }));
  };

  const handleAddObjective = () => {
    setIsOpenModalFormObjective(true);
  };

  const handleEditObjective = id => {
    setIsOpenModalFormObjective(true);
    setIdSelectedObjective(id);
  };

  const handleCopyObjective = id => {
    setOpenModalFormCopyObjective(true);
    setIdSelectedObjective(id);
  };

  const handleCopyKr = itemKr => {
    setKrBaseSelected(itemKr);
    setIdSelectedObjective(itemKr.objectiveId);
    setOpenModalFormCopyKR(true);
  };

  const handleEditKr = itemKr => {
    setEdit(true);
    setKrBaseSelected(itemKr);
    setIdSelectedObjective(itemKr.objectiveId);
    setOpenModalFormCopyKR(true);
  };

  const handleCloseModelCopyObjective = (isReload = false, idObjective = undefined) => {
    setOpenModalFormCopyObjective(false);
    setIdSelectedObjective(null);
    if (isReload) {
      getAllEntities();
    }
    if (idObjective) {
      handleAddKr(idObjective);
    }
  };

  const handleCloseModelObjective = (isReload = false, idObjective = undefined) => {
    setIsOpenModalFormObjective(false);
    setIdSelectedObjective(null);
    if (isReload) {
      getAllEntities();
    }
    if (idObjective) {
      getAllEntities();
      handleAddKr(idObjective);
    }
  };


  const handleCloseModalAdjustmentYear = () => {
    setOpenModalAdjustmentYear(false);
  }

  const handleAddKr = idObjective => {
    setOpenModalFormCopyKR(true);
    setIdSelectedObjective(idObjective);
  };

  const handleCloseModelCopyKr = (isReload = false) => {
    setOpenModalFormCopyKR(false);
    setKrBaseSelected(null);
    setEdit(false);
    setIdSelectedObjective(null);
    if (isReload) {
      getAllEntities();
    }
  };

  const handleViewListKr = (idObjective) => {
    navigate(idObjective)
  }

  const handleAddActivities = (item) => {
    setOpenModalFormActivities(true);
    setSelectedObjective(item)
  };

  const handleCloseModelActivities = () => {
    setOpenModalFormActivities(false);
    setSelectedObjective(null)
  };

  const onMenuClick = e => {
    const { key } = e;
    switch (parseInt(key, 10)) {
      case 2:
        handleOpenModalCheckIn();
        break;
      case 3:
        handleOpenModalCheckInList();
        break;
      case 4:
        handleTypeKrConfirmComplete();
        return;
      default:
        break;
    }
  };

  const onMenuApproveClick = e => {
    const { key } = e;
    switch (parseInt(key, 10)) {
      case 1:
        handleOpenModalApprove();
        break;
      case 2:
        handleOpenModalConfirmApprove();
        break;
      case 3:
        handleOpenModalCategoryApprove();
        return;
      case 5:
        handleOpenModalAdjustedObjective();
        return;
      case 6:
        handleOpenModalAdjustmentYear();
        return;
      default:
        break;
    }
  };

  const onMenuEvaluationClick = e => {
    const { key } = e;
    switch (parseInt(key, 10)) {
      case 1:
        handleOpenModalEvaluation();
        break;
      case 2:
        handleOpenModalCategoryEvaluation();
        break;
      case 3:
        handleOpenModalResultComplete();
        return;
      default:
        break;
    }
  };

  // Handle open and close model approve
  const handleOpenModalApprove = () => {
    setOpenModalApprove(true);
  }

  const handleCloseModalApprove = () => {
    setOpenModalApprove(false);
  }
  // Handle open and close model evaluate
  const handleOpenModalEvaluation = () => {
    setOpenModalEvaluation(true);
  }

  const handleCloseModalEvaluation = () => {
    setOpenModalEvaluation(false);
  }

  const handleOpenModalCategoryEvaluation = () => {
    setOpenModalCategoryEvaluation(true); //
  }

  const handleCloseModalCategoryEvaluation = () => {
    setOpenModalCategoryEvaluation(false);
  }

  const handleOpenModalCheckIn = () => {
    setOpenModalCheckIn(true); //
    dispatch(setFilterOrgCheckIn(filters));
  }

  const handleCloseModalCheckIn = (isReload) => {
    setOpenModalCheckIn(false);
    if (isReload) {
      getAllEntities();
    }
  }

  const handleOpenModalCheckInList = () => {
    dispatch(setListFilterOrgCheckIn(filters))
    setOpenModalCheckInList(true); //
  }

  const handleCloseModalCheckInList = () => {
    setOpenModalCheckInList(false);
  }

  const handleOpenModalCategoryApprove = () => {
    setOpenModalCategoryApprove(true); //
  }

  const handleCloseModalCategoryApprove = () => {
    setOpenModalCategoryApprove(false);
    // Không reset toàn bộ state để tránh mất dữ liệu entity và entityAdjustment
    // dispatch(reset())
    // Chỉ reset những phần cần thiết nếu cần
    dispatch(resetApprovalEntity())
  }

  const handleOpenModalAdjustedObjective = () => {
    if (selectedRowKeys.length <= 0) {
      notification.warning({ placement: 'topLeft', message: 'Vui lòng chọn mục tiêu, KR để trình phê duyệt' });
      return;
    }
    else {
      const dataMapper = data.filter(parent => selectedRowKeys.includes(parent.id)).map(x => ({
        contribution: x.contribution,
        children: x.children?.filter(child => selectedRowKeys.includes(child.id)).map(c => c.krContribution)
      }));

      // Kiểm tra tổng contribution của cha
      const totalParentContribution = dataMapper.reduce((sum, item) => sum + item.contribution, 0);

      // Kiểm tra tổng contribution của từng nhóm con
      // const childrenContributionsValid = dataMapper.filter(x => x.children && x.children.length > 0).every(item => {
      //   const totalChildContribution = item.children.reduce((sum, c) => sum + c, 0);
      //   return Math.round(totalChildContribution) === 1;
      // });

      if (Math.round(totalParentContribution) !== 1) {
        notification.warning({ placement: 'topLeft', message: 'Trọng số của mục tiêu, kr chưa đủ 100%. Vui lòng kiểm tra lại' });
        return;
      }

      setOpenModalAdjustedObjective(true);
    }
  }

  const handleCloseModalAdjustedObjective = () => {
    setOpenModalAdjustedObjective(false);
  }

  const handleOpenModalAdjustmentYear = () => {
    setOpenModalAdjustmentYear(true);
  }


  const handleTypeKrConfirmComplete = async () => {
    dispatch(setFilterOrgCheckIn(filters));
    console.log(filters);
    const response = await dispatch(getCurrentCheckInType())
    if (response && response.payload) {
      const result = response.payload as any
      switch (result.data.checkinType) {
        case 0:
          setOpenModalConfirmCompleteHalfMonth(true);
          break;
        case 1:
          setOpenModalConfirmCompleteMonth(true);
          break;
        case 2:
          setOpenModalConfirmComplete(true)
          break;
        case 3:
          setOpenModalConfirmCompleteQuarter(true)
          break;
        case 4:
          break;
        default:
          return;
      }
    }
  }

  const handleTypeKrCheckIn = async (item) => {
    const response = await dispatch(getCurrentCheckInType())
    if (response && response.payload) {
      const result = response.payload as any
      switch (result.data.checkinType) {
        case 0:
          handleOpenModalReportKrHalfMonth(item);
          break;
        case 1:
          handleOpenModalReportKrMonth(item);
          break;
        case 2:
          handleOpenModalReportKr(item)
          break;
        case 3:
          handleOpenModalReportKrFirstQuarter(item)
          break;
        case 4:

          break;
        default:
          return;
      }
    }
  }

  const handleOpenModalReportKrFirstQuarter = (dataKr = null) => {
    if (dataKr) {
      setKrBaseSelected(dataKr)
    }
    setOpenModalReportKrFirstQuarter(true);
  };

  const handleCloseModalReportKrFirstQuarter = () => {
    setOpenModalReportKrFirstQuarter(false);
    setKrBaseSelected(null)
    getAllEntities();
  };

  const handleOpenModalReportKr = (dataKr = null) => {
    if (dataKr) {
      setKrBaseSelected(dataKr)
    }
    setOpenModalReportKr(true);
  };

  const handleCloseModalReportKr = () => {
    setOpenModalReportKr(false);
    setKrBaseSelected(null)
    getAllEntities();
  };

  const handleOpenModalReportKrMonth = (dataKr = null) => {
    if (dataKr) {
      setKrBaseSelected(dataKr)
    }
    setOpenModalReportKrMonth(true);
  };

  const handleCloseModalReportKrMonth = (isReload = false) => {
    setOpenModalReportKrMonth(false);
    setKrBaseSelected(null)
    if (isReload) {
      getAllEntities();
    }
  };

  const handleOpenModalReportKrHalfMonth = (dataKr = null) => {
    if (dataKr) {
      setKrBaseSelected(dataKr)
    }
    setOpenModalReportKrHalfMonth(true);
  };

  const handleCloseModalReportKrHalfMonth = (isReload = false) => {
    setOpenModalReportKrHalfMonth(false);
    setKrBaseSelected(null)
    if (isReload) {
      getAllEntities();
    }
  };

  const handleOpenModalContribution = () => {
    if (!filters.planPeriodId) {
      notification.warning({ placement: 'top', message: 'Vui lòng chọn kỳ kế hoạch' });
      return;
    }
    setOpenModalContribution(true);
  };

  const handleCloseModalContribution = (isReload = false) => {
    setOpenModalContribution(false);
    if (isReload) {
      getAllEntities();
    }
  };

  const handleRightClick = (event, record, rowIndex) => {
    localStorage.setItem('scrollToRow', record.code);
    event.preventDefault();
    const { clientX, clientY } = event;
    if (_.startsWith(record.code, ObjectiveSymbol, 0)) {
      setContextMenuObjective(
        <Menu>
          {dropDownAction
            .map(item =>
              item.show && <Menu.Item key={item.key} onClick={() => { item.onclick(record) }}>{item.label}</Menu.Item>
            )}
        </Menu>
      );
      setMenuObjectivePosition({ x: clientX, y: clientY });
    }
    else {
      setContextMenuKr(
        <Menu>
          {dropDownKrAction
            .map(item =>
              item.show && <Menu.Item key={item.key} onClick={() => { item.onclick(record) }}>{item.label}</Menu.Item>
            )}
        </Menu>
      );
      setMenuKrPosition({ x: clientX, y: clientY });
    }
  };

  const handleOpenModalExport = () => {
    setOpenModalExport(true);
  }

  const handleCloseModalExport = () => {
    setOpenModalExport(false);
  }

  const handleOpenModalListKrCopy = (itemObj) => {
    setOpenModalListKrCopy(true);
    setSelectedObjective(itemObj)
  }

  const handleCloseModalListKrCopy = () => {
    setOpenModalListKrCopy(false);
    setSelectedObjective(null)
    getAllEntities();
  }

  const handleCloseFilter = (item) => {
    const { krAccountableId, fieldValue, projectId, workStatus, workTypeId } = item;
    dispatch(
      setFilterObjective({
        ...filters,
        krAccountableId,
        fieldValue,
        projectId,
        workStatus,
        workTypeId,
      }),
    );
    setFilterModalVisible(false)
  }

  const onSelectChange = (newSelectedRowKeys: React.Key[], selectedRows) => {
    // If a parent is deselected, do not remove all children at once
    const selectedKeys = [...newSelectedRowKeys];
    const previousSelectedKeys = [...selectedRowKeys];
    // Find deselected keys (items that were previously selected but are now removed)
    const deselectedKeys = previousSelectedKeys.filter(key => !newSelectedRowKeys.includes(key));

    const parentKeys: any = data.filter(row => selectedKeys.includes(row.id) ||
      (row.children &&
        row.children.some(child => selectedKeys.includes(child.id))) // ✅ Select parent only if all children are selected
    );
    if (deselectedKeys.length > 0) {
      parentKeys.forEach(parent => {
        // If at least one child is selected, add the parent
        if (parent.children && (parent.children.every(child => !selectedKeys.includes(child.id)) || deselectedKeys.includes(parent.id))) {
          const ids = parent.children.map(child => child.id);
          _.remove(selectedKeys, o => { return ids.includes(o) });
          _.remove(selectedKeys, id => id === parent.id);
        }
      });
    }
    else {
      parentKeys.forEach(parent => {
        // If at least one child is selected, add the parent
        if (parent.children && parent.children.some(child => selectedKeys.includes(child.id))) {
          if (!selectedKeys.includes(parent.id)) {
            selectedKeys.push(parent.id);
          }
        }
        // If the parent is selected, add all children
        else if (selectedKeys.includes(parent.id) && parent.children) {
          const childIds = parent.children?.map(child => child.id);
          selectedKeys.push(...childIds);
        }
      });
    }

    setSelectedRowKeys(_.uniq(selectedKeys));
  };

  const rowSelection: TableRowSelection<any> = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleOpenModalConfirmApprove = () => {
    if (selectedRowKeys.length <= 0) {
      notification.warning({ placement: 'topLeft', message: 'Vui lòng chọn mục tiêu, KR để trình phê duyệt' });
      return;
    }
    else {
      const dataMapper = data.filter(parent => selectedRowKeys.includes(parent.id)).map(x => ({
        contribution: x.contribution,
        children: x.children?.filter(child => selectedRowKeys.includes(child.id)).map(c => c.krContribution)
      }));

      // Kiểm tra tổng contribution của cha
      const totalParentContribution = dataMapper.reduce((sum, item) => sum + item.contribution, 0);

      // Kiểm tra tổng contribution của từng nhóm con
      const childrenContributionsValid = dataMapper.filter(x => x.children && x.children.length > 0).every(item => {
        const totalChildContribution = item.children.reduce((sum, c) => sum + c, 0);
        return Math.round(totalChildContribution) === 1;
      });

      if (Math.round(totalParentContribution) !== 1) {
        notification.warning({ placement: 'topLeft', message: 'Trọng số của mục tiêu, kr chưa đủ 100%. Vui lòng kiểm tra lại' });
        return;
      }
      setOpenModalConfirmApprove(true);
      dispatch(setFilterPendingApprove({ ...filters }))
    }
  }

  const handleCloseModalConfirmApprove = () => {
    setOpenModalConfirmApprove(false);
  }

  const handleOpenModalResultComplete = () => {
    setOpenModalResultComplete(true);
  }

  const handleCloseModalResultComplete = () => {
    setOpenModalResultComplete(false);
  }

  const handleFetCurrentStatusProcessEvaluate = (accountableId: string, year: number) => {
    dispatch(fetchCurrentStatusProcess({ ownerId: accountableId, year, planPeriodId: filters.planPeriodId }));
  }

  const handleFetCurrentStatusProcessApprove = (accountableId: string, year: number) => {
    dispatch(getCurrentStatusProcess({ ownerId: accountableId, year, planPeriodId: filters.planPeriodId }));
  }

  const handleFetCurrentStatusProcessAdjustment = (accountableId: string, year: number) => {
    dispatch(getCurrentStatusProcessAdjustment({ ownerId: accountableId, year, planPeriodId: filters.planPeriodId }));
  }

  // drag and drop
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        // https://docs.dndkit.com/api-documentation/sensors/pointer#activation-constraints
        distance: 1,
      },
    }),
  );

  const handleDragEnd = async (event) => {
    const { active, over }: DragEndEvent = event;

    if (!over) return;

    const activeKey = active.id;
    const overKey = over.id;

    // Find the parent of the active and over items
    const findParent = (items, key) => {
      return _.find(items, o => { return _.some(o.children, i => i.id === key) });
    };

    const activeParent = findParent(data, activeKey);
    const overParent = findParent(data, overKey);

    if (activeParent && overParent && activeParent.id === overParent.id) {
      // Move within the same parent
      const activeIndex = activeParent.children.findIndex((i) => i.id === activeKey);
      const overIndex = activeParent.children.findIndex((i) => i.id === overKey);
      const newChildren: any[] = arrayMove(
        activeParent.children,
        activeIndex,
        overIndex
      );

      const updatedData = data.map((item) =>
        item.id === activeParent.id ? { ...item, children: newChildren } : item
      );

      setData(updatedData)
      const result = await handleUpdateOrderItem(newChildren, activeKey)
      if (!result) setData(data);

    } else if (!activeParent && !overParent) {
      const activeIndex = data.findIndex((i) => i.id === activeKey);
      const overIndex = data.findIndex((i) => i.id === overKey);
      const updatedData = arrayMove(data, activeIndex, overIndex);

      setData(updatedData)
      const result = await handleUpdateOrderItem(updatedData, activeKey)
      if (!result) setData(data);
    }
  };

  const handleExpandedRowKeys = () => {
    if (expandedRowKeys.length > 0)
      setExpandedRowKeys([]);
    else {
      const allRowKeys = getAllRowKeys(objectiveList);
      setExpandedRowKeys(allRowKeys);
    }
  }

  const handleUpdateOrderItem = async (arrayAfterOrder = [], activeItemId) => {
    const activeNewIndex = arrayAfterOrder.findIndex((i) => i.id === activeItemId);
    const payload = {
      previousItemId: arrayAfterOrder[activeNewIndex - 1]?.id,
      itemId: activeItemId,
      nextItemId: arrayAfterOrder[activeNewIndex + 1]?.id
    }
    const res = await dispatch(dragAndDropItem(payload))
    return !!(res && res.payload);
  }


  return (
    <Container className="view">
      <div className="d-flex gap-5 mt-2">
        <Row className="d-flex justify-content-between w-100">
          <Col md={24}>
            <Row>
              <Col md={14} className='d-flex gap-3 align-item-center'>
                <Title level={3}>Danh sách mục tiêu</Title>
                <Select
                  filterOption={filterOption}
                  className='filter-account'
                  onChange={handleChangeEmployee}
                  value={filters?.accountableId}
                  showSearch
                  size="large"
                  options={employeeList.map(x => {
                    return {
                      label: x.name,
                      value: x.id,
                    };
                  })}
                  placeholder="Chọn bên nhận mục tiêu"
                />
              </Col>
              <Col md={10}>
                <div className='d-flex gap-2 flex-wrap justify-content-end pad-right-10'>
                  <Dropdown
                    className="green"
                    trigger={['click']}
                    menu={{ items: actionsObjective, onClick: onMenuClick }}
                    placement="bottomCenter"
                  >
                    <Button size="large" disabled={isCheckInDisabled}>
                      <DownOutlined /> Check in
                    </Button>
                  </Dropdown>
                  <Button size="large"
                    className="green" onClick={handleOpenModalContribution}>
                    Cân đối tý trọng
                  </Button>
                  <Dropdown
                    className="green"
                    trigger={['click']}
                    menu={{ items: actionsApprove, onClick: onMenuApproveClick }}
                    placement="bottomCenter"
                  >
                    <Button size="large">
                      <DownOutlined /> Phê duyệt
                    </Button>
                  </Dropdown>
                  <Dropdown
                    className="green"
                    trigger={['click']}
                    menu={{ items: actionsEvaluation, onClick: onMenuEvaluationClick }}
                    placement="bottomCenter"
                  >
                    <Button size="large">
                      <DownOutlined /> Đánh giá
                    </Button>
                  </Dropdown>
                </div>
              </Col>

            </Row>
          </Col>
        </Row>
      </div>
      <div className="table">
        <div className="header">
          <Col md={15}>
            <Row className='w-100' gutter={16}>
              <Col md={4}>
                <Select
                  className="w-100"
                  value={filters?.planPeriodId}
                  showSearch
                  options={planPeriodList.map(x => {
                    return {
                      value: x.id,
                      label: x.name,
                    };
                  })}
                  onChange={handleChangePlanPeriod}
                  filterOption={filterOption}
                  placeholder="Chọn kỳ kế hoạch"
                  size="large"
                />
              </Col>
              {filters?.planPeriodType === PlantPeriodType.Year && (
                <>
                  <Col md={5}>
                    <Select
                      className="w-100"
                      value={filters?.adjustPlanPeriod}
                      options={versionPlanPeriodYear}
                      onChange={handleChangeAdjustPlanPeriods}
                      filterOption={filterOption}
                      placeholder="Chọn phiên bản"
                      size="large"
                    />
                  </Col>
                </>
              )}
              {filters?.planPeriodType === PlantPeriodType.Month && (
                <>
                  <Col md={5}>
                    <Select
                      className="w-100"
                      value={filters?.reportScheduleId}
                      options={reportSchedules}
                      onChange={handleChangeReportSchedule}
                      filterOption={filterOption}
                      placeholder="Chọn kỳ báo cáo"
                      size="large"
                    />
                  </Col>
                </>
              )}
              {/* <Col md={1} />
              <Col md={6}>
                <Select
                  className="w-100"
                  value={filters?.includeKr}
                  onChange={handleChangeDisplayTable}
                  options={displayTable}
                  filterOption={filterOption}
                  size="large"
                />
              </Col> */}
              <Col md={1} />
              {(filters?.planPeriodType === PlantPeriodType.Month || filters?.planPeriodType === PlantPeriodType.Year) ?
                <Col md={13}>
                  <Search size="large" className='w-100' allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
                </Col> :
                <Col md={18}>
                  <Search size="large" className='w-100' allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
                </Col>}
              <Col md={1}>
                <Button
                  className={`filter primary ${(filters?.krAccountableId ||
                    filters?.fieldValue ||
                    filters?.projectId ||
                    filters?.workStatus || filters?.workTypeId) ? 'active-filter' : ''}`}
                  size="large"
                  onClick={() => {
                    setFilterModalVisible(true);
                  }}
                  icon={<ReactSVG src={'content/images/icons/filter.svg'} />}
                />
              </Col>
            </Row>
          </Col>
          <Col md={9}>
            <Row className='w-100 justify-content-end gap-1'>
              <Col>
                <Button className="primary" size="large" onClick={() => { handleOpenModalExport() }}>
                  Xuất File Excel
                </Button>
              </Col>
              <Col>
                <Button className="primary" size="large" onClick={handleExpandedRowKeys}>
                  {expandedRowKeys.length > 0 ? `Hiển thị theo mục tiêu` : 'Hiển thị theo Mục tiêu và KR'}
                </Button>
              </Col>
              <Col>
                <Button
                  size="large"
                  onClick={() => {
                    handleAddObjective();
                  }}
                  className="primary"
                  icon={<PlusOutlined />}
                >
                  Thêm mới mục tiêu
                </Button>
              </Col>
            </Row>
          </Col>

        </div>
      </div>
      <DndContext sensors={sensors}
        modifiers={[restrictToVerticalAxis]}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          // rowKey array
          items={[...data.map((item) => ({ ...item, key: item.id })), ...data.flatMap((item) => item.children?.map((child) => ({ ...child, key: child.id })) || [])]}
          strategy={verticalListSortingStrategy}
        >
          <TableComponent
            data={data}
            components={{
              body: {
                row(props) {
                  // Lấy key của hàng hiện tại từ props
                  const rowKey = props["data-row-key"];
                  // Hàm kiểm tra xem rowKey có phải là một "cha"
                  const isParent = data.some((item) => item.id === rowKey);
                  // Nếu là hàng cha và nó nằm trong expandedRowKeys, chặn kéo
                  if (isParent && expandedRowKeys.includes(rowKey)) {
                    return <tr {...props} />;
                  }
                  // Nếu không phải là hàng cha, hoặc hàng cha không mở, cho phép kéo
                  return <DraggableRow {...props} />;
                }
              },
            }}
            positionPagination={['topLeft']}
            scroll={true}
            total={totalItems}
            isFetching={isLoading || updating}
            rowSelection={rowSelection}
            tableLayout="fixed"
            columns={newColumns}
            expandedRowKeys={expandedRowKeys}
            handleRightClick={(event, record, index) => { handleRightClick(event, record, index) }}
            expandIconColumnIndex={4}
            setExpandedRowKeys={setExpandedRowKeys}
            handlePageChange={(pageNumber: number, size: number, search: any, sorter: any) => {
              handleChange(pageNumber, size, sorter);
            }}
          />
        </SortableContext>
      </DndContext>
      {contextMenuObjective && (
        <Dropdown
          overlay={contextMenuObjective}
          open
          trigger={['contextMenu']}
          placement="bottomLeft"
          onOpenChange={(flag) => !flag && setContextMenuObjective(null)}
          overlayStyle={{
            position: 'fixed',
            top: menuObjectivePosition.y,
            left: menuObjectivePosition.x,
            zIndex: 1000,
          }}
        >
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100vh' }} />
        </Dropdown>
      )}
      {contextMenuKr && (
        <Dropdown
          overlay={contextMenuKr}
          open
          trigger={['contextMenu']}
          placement="bottomLeft"
          onOpenChange={(flag) => !flag && setContextMenuKr(null)}
          overlayStyle={{
            position: 'fixed',
            top: menuKrPosition.y,
            left: menuKrPosition.x,
            zIndex: 1000,
          }}
        >
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100vh' }} />
        </Dropdown>
      )}
      {visibleFilter && <FilterModal visible={visibleFilter} onCancel={handleCloseFilter} />}
      {isOpenModalFormActivities && <ActivitiesUpdate isOpen={isOpenModalFormActivities} objectiveSelected={objectiveSelected} onClose={handleCloseModelActivities} />}
      {isOpenModalFormObjective && (
        <ObjectiveUpdate isOpen={isOpenModalFormObjective} id={idSelectedObjective} onClose={handleCloseModelObjective} />
      )}
      {isOpenModalFormCopyObjective &&
        <CopyObjective
          isOpen={isOpenModalFormCopyObjective}
          onClose={handleCloseModelCopyObjective}
          id={idSelectedObjective}
        />
      }
      {isOpenModalConfirmComplete &&
        <ConfirmComplete
          isOpen={isOpenModalConfirmComplete}
          onClose={() => {
            setOpenModalConfirmComplete(false);
          }}
        />
      }
      {isOpenModalConfirmCompleteQuarter &&
        <ConfirmCompleteQuarter
          isOpen={isOpenModalConfirmCompleteQuarter}
          onClose={() => {
            setOpenModalConfirmCompleteQuarter(false);
          }}
        />
      }
      {isOpenModalConfirmCompleteHalfMonth &&
        <ConfirmCompleteHalfMonth
          isOpen={isOpenModalConfirmCompleteHalfMonth}
          onClose={() => {
            setOpenModalConfirmCompleteHalfMonth(false);
          }}
        />
      }
      {isOpenModalConfirmCompleteMonth &&
        <ConfirmCompleteMonth
          isOpen={isOpenModalConfirmCompleteMonth}
          onClose={() => {
            setOpenModalConfirmCompleteMonth(false);
          }}
        />
      }
      {isOpenModalFormCopyKR && (
        <CopyKR
          krTypeRequest={krBaseSelected?.krType}
          isOpen={isOpenModalFormCopyKR}
          idKrBaseSelected={krBaseSelected?.id}
          planPeriodIdSelected={filters?.planPeriodId}
          planPeriodType={filters?.planPeriodType}
          idObjective={idSelectedObjective}
          onClose={handleCloseModelCopyKr}
          isEdit={isEdit}
        />
      )}
      {/* {isOpenModalFormKr && (
        <KRUpdate
          krTypeRequest={krBaseSelected?.krType}
          isOpen={isOpenModalFormKr}
          idKrBaseSelected={krBaseSelected?.id}
          planPeriodIdSelected={filters?.planPeriodId}
          planPeriodType={filters?.planPeriodType}
          idObjective={idSelectedObjective}
          onClose={handleCloseModelKr}
        />
      )} */}
      {isOpenModalExport &&
        <ExportExcelComponent isOpen={isOpenModalExport} onClose={() => { handleCloseModalExport() }} />
      }
      {isOpenModalContribution &&
        <AdjustWeight isOpen={isOpenModalContribution} onClose={(reload) => { handleCloseModalContribution(reload) }} />
      }
      {isOpenModalReportKrHalfMonth && <ReportHalfMonth krSelected={krBaseSelected} isOpen={isOpenModalReportKrHalfMonth} onClose={handleCloseModalReportKrHalfMonth} />}
      {isOpenModalReportKrMonth && <ReportMonth krSelected={krBaseSelected} isOpen={isOpenModalReportKrMonth} onClose={handleCloseModalReportKrMonth} />}
      {isOpenModalReportKr && <ReportMidYear krSelected={krBaseSelected} isOpen={isOpenModalReportKr} onClose={handleCloseModalReportKr} />}
      {isOpenModalReportKrFirstQuarter && <ReportQuarter krSelected={krBaseSelected} isOpen={isOpenModalReportKrFirstQuarter} onClose={handleCloseModalReportKrFirstQuarter} />}
      {isOpenModalCheckInList && <CheckInListComponent isOpen={isOpenModalCheckInList} onClose={handleCloseModalCheckInList} />}
      {isOpenModalCheckIn && <OrganizationActiveCheckIn isOpen={isOpenModalCheckIn} onClose={handleCloseModalCheckIn} />}
      {isOpenModalApprove && <ApprovalLevel isOpen={isOpenModalApprove} onClose={handleCloseModalApprove} />}
      {isOpenModalEvaluation && <EvaluationLevel isOpen={isOpenModalEvaluation} onClose={handleCloseModalEvaluation} />}
      {isOpenModalListKrCopy && <CopyKRComponent isOpen={isOpenModalListKrCopy} onClose={handleCloseModalListKrCopy} idObjectiveSelected={objectiveSelected?.id} />}
      {isOpenModalCategoryApprove && <CategoryApproveComponent planPeriodId={filters?.planPeriodId} isOpen={isOpenModalCategoryApprove} onClose={handleCloseModalCategoryApprove} />}
      {isOpenModalCategoryEvaluation && <CategoryEvaluationComponent planPeriodId={filters?.planPeriodId} isOpen={isOpenModalCategoryEvaluation} onClose={handleCloseModalCategoryEvaluation} />}
      {isOpenModalResultComplete && <ResultCompleteComponent isOpen={isOpenModalResultComplete} onClose={handleCloseModalResultComplete} />}
      {isOpenModalConfirmApprove && <PendingApproval selectedPeriod={filters?.planPeriodId} itemsSelected={selectedRowKeys as string[]} isOpen={isOpenModalConfirmApprove} onClose={handleCloseModalConfirmApprove} />}
      {isOpenModalAdjustedObjective && <ApproveAdjustedObjectiveKRComponent itemsSelected={selectedRowKeys as any} isOpen={isOpenModalAdjustedObjective} onClose={handleCloseModalAdjustedObjective} documentId={idSelectedObjective} accountTableId={objectiveSelected?.id} accountableName={filters?.accountableName} />}
      {isOpenModalAdjustmentYear && <ApproveAdjustedYearComponent isOpen={isOpenModalAdjustmentYear} onClose={handleCloseModalAdjustmentYear} documentId={idSelectedObjective} accountTableId={objectiveSelected?.id} accountableName={filters?.accountableName} itemsSelected={selectedRowKeys as any} />}
      <ModalConfirmComponent
        visible={visibleConfirmDelete}
        onCancel={() => {
          setVisibleConfirmDelete(false);
        }}
        onConfirm={handleConfirmDelete}
        title={`Bạn có muốn xóa ${idSelectedObjective ? 'mục tiêu' : 'kr'}`}
      />
    </Container>
  );
};

export default Objective;
